module.exports = __webpack_public_path__ + "5823-info_bg.png";